import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const CustomAutocomplete = styled(Autocomplete)({
  '& .MuiFormControl-root': {
    marginTop: '14px',
  },
  '& .MuiOutlinedInput-root': {
    padding: '0px 4px 0px 0px',
    border: 'none', // Remove the border
    '& fieldset': {
      border: 'none', // Remove the border from the fieldset
    },
  },
  '& .MuiAutocomplete-inputRoot': {
    padding: '0px 0px 0px px',
  },
  '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
    padding: '0px 0px 0px 0px', // Adjust the padding as specified
  },
  '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot': {
    paddingRight: '0px',
  },
});

function MuiSelect({ options, placeholder, value, onChange,  required = false, ...prop }) {
  return (
    <CustomAutocomplete
      required={required}
      value={value}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      options={options}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="outlined"
        />
      )}
    />
  );
}

MuiSelect.propTypes = {
  options:PropTypes.array,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default MuiSelect;